module.exports = __webpack_public_path__ + "static/media/logo.45751ec2.svg";